import {DateTimePicker} from "@mui/x-date-pickers";
import {FormControl, InputLabel, MenuItem, Select, SelectChangeEvent, Stack} from "@mui/material";
import {IdeaEditStepProps} from "./EditIdeaPage.tsx";
import {useCallback} from "react";

export default function DateChooserStep(props: IdeaEditStepProps) {

    const [idea, setIdea] = props.control

    const handleStartsAtChange = useCallback((newStartsAt: Date | null) => {
        if (newStartsAt == null) {
            // ignore null values
            return
        }
        setIdea((idea) => ({...idea, startsAt: newStartsAt}))
    }, [idea])

    const handleDurationChange = useCallback((event: SelectChangeEvent) => {
        let newDuration: number = +event.target.value
        setIdea((idea) => ({...idea, duration: newDuration}))
    }, [idea])

    return (
        <>
            <Stack direction="column" spacing={4} sx={{marginTop: 2}}>

                <DateTimePicker
                    label="Start"
                    value={idea.startsAt}
                    minDate={new Date()}
                    onChange={handleStartsAtChange}
                    views={['month', 'day', 'hours', 'minutes']}
                />

                <FormControl>
                    <InputLabel id="duration-select-label">Dauer</InputLabel>
                    <Select
                        id="duration-select"
                        value={`${idea.duration}`}
                        onChange={handleDurationChange}
                        label="Dauer"
                        variant={"outlined"}
                    >
                        <MenuItem value={1}>1 Stunde</MenuItem>
                        <MenuItem value={2}>2 Stunden</MenuItem>
                        <MenuItem value={3}>3 Stunden</MenuItem>
                        <MenuItem value={4}>4 Stunden</MenuItem>
                        <MenuItem value={5}>5 Stunden</MenuItem>
                        <MenuItem value={6}>6 Stunden</MenuItem>
                    </Select>
                </FormControl>

            </Stack>
        </>
    )
}